// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-EntityList-FilterSwitch-FilterSwitch-module__container--umPgI {
  white-space: nowrap;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/EntityList/FilterSwitch/FilterSwitch.module.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  white-space: nowrap;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-pages-EntityFiltersPage-EntityList-FilterSwitch-FilterSwitch-module__container--umPgI`
};
export default ___CSS_LOADER_EXPORT___;
